import BaseModel from 'src/model/base.model';

interface IProduct {
  categoryId: string;
  categoryName: string;
  manufacturer: string;
  productNumber: string;
  ranking: number;
  score: number;
  subcategoryId: string;
  subcategoryName: string;
  id: string;
  description: string;
  dbId: string;
  name: string;
  category: string;
  version: string;
  subPartNumber	: string;
}
interface IRPModel {
  id: string;
  brand: string;
  manufacturer: string;
  dbId: string;
  name: string;
  type: string;
  version: string;
  applianceType?: string;
}
export default class SearchModelProduct extends BaseModel {
  public hasExactResult: boolean;
  public totalFound: number;
  public modelsFound: number;
  public productFound: number;
  public models: IRPModel[];
  public products: IProduct[];

  constructor() {
    super();
    this.totalFound = 0;
    this.modelsFound = 0;
    this.productFound = 0;
    this.models = [];
    this.products = [];
  }
}
